var _a;
import { Navigation, Pagination } from 'swiper/modules';
import Swiper from 'swiper';
import configureSelectField from '../parts/select-books-shop';
const initBlockBooksHomepage = () => {
    configureSelectField('select-books');
    let booksSlide = new Swiper('.js-books-slider', {
        spaceBetween: 24,
        slidesPerView: 1,
        navigation: {
            nextEl: '.books-button-next',
            prevEl: '.books-button-prev',
        },
        pagination: {
            el: '.books-pagination',
            type: 'bullets',
            clickable: true,
        },
        modules: [Navigation, Pagination],
        breakpoints: {
            1200: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2,
            },
        },
    });
};
document.addEventListener('DOMContentLoaded', initBlockBooksHomepage, false);
if (window['acf']) {
    (_a = window['acf']) === null || _a === void 0 ? void 0 : _a.addAction('render_block_preview', initBlockBooksHomepage);
}
